// extracted by mini-css-extract-plugin
export default {"PricingPlansCard":"style-module__PricingPlansCard____yGLX","PricingPlansCard__content":"style-module__PricingPlansCard__content___TMZjM"};